"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShallowStockItem = void 0;
// tslint:disable
const BaseAvroRecord_1 = require("../../../BaseAvroRecord");
class ShallowStockItem extends BaseAvroRecord_1.BaseAvroRecord {
    constructor() {
        super(...arguments);
        this.contentId = null;
        this.distributionTypeUpdatedDate = null;
        this.format = null;
        this.thumbnailUrl = null;
    }
    schema() {
        return ShallowStockItem.schema;
    }
    subject() {
        return ShallowStockItem.subject;
    }
}
exports.ShallowStockItem = ShallowStockItem;
ShallowStockItem.subject = "shallow-stock-item";
ShallowStockItem.schema = {
    "type": "record",
    "name": "ShallowStockItem",
    "namespace": "storyblocks.content.records",
    "fields": [
        {
            "name": "stockItemId",
            "type": "int"
        },
        {
            "name": "contentId",
            "type": [
                "null",
                "int"
            ],
            "default": null
        },
        {
            "name": "title",
            "type": "string"
        },
        {
            "name": "distributionType",
            "type": {
                "type": "enum",
                "name": "DistributionType",
                "namespace": "storyblocks.content.enums",
                "symbols": [
                    "MEMBER_LIBRARY",
                    "REV_SHARE",
                    "MARKETPLACE",
                    "OUTDATED_SCHEMA"
                ],
                "default": "OUTDATED_SCHEMA"
            }
        },
        {
            "name": "publishedDate",
            "type": {
                "type": "long",
                "logicalType": "timestamp-millis"
            }
        },
        {
            "name": "distributionTypeUpdatedDate",
            "type": [
                "null",
                {
                    "type": "long",
                    "logicalType": "timestamp-millis"
                }
            ],
            "default": null
        },
        {
            "name": "contentType",
            "type": {
                "type": "enum",
                "name": "ContentType",
                "namespace": "storyblocks.content.enums",
                "symbols": [
                    "ALL",
                    "LOOPS",
                    "MUSIC",
                    "SOUND_EFFECTS",
                    "ILLUSTRATIONS",
                    "PHOTOS",
                    "SNAPSHOTS",
                    "VECTORS",
                    "FOOTAGE",
                    "MOTION_BACKGROUNDS",
                    "TEMPLATES",
                    "VR_360",
                    "OUTDATED_SCHEMA"
                ],
                "default": "OUTDATED_SCHEMA"
            }
        },
        {
            "name": "format",
            "type": [
                "null",
                "string"
            ],
            "default": null
        },
        {
            "name": "thumbnailUrl",
            "type": [
                "null",
                "string"
            ],
            "default": null
        }
    ]
};
//# sourceMappingURL=ShallowStockItem.js.map